module.exports = __webpack_public_path__ + "mobile/img/img3-618.07d30f89.png";